import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import { UserService } from '../../../../core/user.service';
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-cqmns-scan-defect',
  templateUrl: './cqmns-scan-defect.component.html',
  styleUrls: ['./cqmns-scan-defect.component.css']
})
export class CqmnsScanDefectComponent implements OnInit {
  scansource = '-';
  issues : any    
  prediction: any;
  prediction1: any;
  count: any = 0;
  loader: boolean;
  projectId: any;
  hostUrl;
  buttonDisable=true;
  p:any;
  selected: any=[];
  message: any;
  source: any=[];
  oldField = "";
  order = true;
  isDesc = false;
  sortDescription = "fa fa-sort";
  sortsource = "fa fa-sort";
  sortreview_date = "fa fa-sort";
  project:any;
  projectName:any;
  userId: any;
  constructor(private router: Router, 
    private http: HttpClient, 
    private route: ActivatedRoute, 
    private userService: UserService, private authService: AuthService, 
    private matDialog: MatDialog) {

  }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
      this.userId = localStorage.getItem("userid");

      this.hostUrl= this.userService.getUrl();
     // this.projectId = this.route.snapshot.params['projectId'];
      this.projectId = localStorage.getItem("projectId");
      this.projectName = localStorage.getItem("cqm-project-name");
      //this.loader = true;
      this.setProjectName(this.projectId);
      /* Make a request to the source to scan all issues */
       this.http.get(encodeURI(this.hostUrl+'/api/jira/scan/' + this.projectId)).subscribe(data => {
          this.http.get(encodeURI(this.hostUrl+'/api/issue/byclassstatus/' + this.projectId + '/0')).subscribe(data => {
               this.loader = false;
               this.issues = data;
              this.count = this.issues.length;
          });
      });
      this.http.get(encodeURI(this.hostUrl+'/api/issue/sourceClassification/' + this.projectId))
      .subscribe( data => {
          this.message=data;
          for(let i =0; i<=this.message.length;i++){
            if(this.message[i]){
               this.source = this.message[i].SOURCE;
            }
          }
          });
  }

  setProjectName(projectId) {
    if (!this.projectName) {
      this.http
        .get(
          encodeURI(
            this.hostUrl + "/api/issue/activatedProjects/" + projectId
          )
        )
        .subscribe(data => {
          this.project = data;
          for (let i = 0; i <= this.project.length; i++) {
            if (this.project[i]) {
              this.projectName = this.project[i].project_name;
            }
          }
        });
    }
  }

  checkboxChecked(status){
      this.buttonDisable=false;
    }
    checkAll(event) {
      const checked = event.target.checked;
      if (checked) {
        this.buttonDisable=false;
        for( let i = 0 ; i<this.count ; i++){
        this.issues.forEach(element => {
          element.checked = true;            
          this.selected.push(this.issues[i].ISSUEID);
        });
      }
      } else {
        this.buttonDisable=true;
        this.issues.forEach(element => {
          element.checked = false;
          this.selected= [];
        });
      }
      console.log(this.selected)
    }  
    testissueCheckbox(issue, event) {
      this.buttonDisable=false;
      console.log(event.target.checked);
      const checked = event.target.checked; // stored checked value true or false
      if (checked) {
        const demoObj = {};
        demoObj['id'] = issue.ISSUEID;   
        demoObj['Defect Description'] = issue.DESCRIPTION;  
        demoObj['data_Source'] = issue.SOURCE;        
        var elementPos = this.issues.map(function (x) { return x.ISSUEID; }).indexOf(issue.ISSUEID);
        this.issues[elementPos].checked = true;
        this.selected.push(demoObj);
      } else {
        const index = this.selected.findIndex(list => list.id == issue.id); //Find the index of stored id
        this.selected.splice(index, 1); // Then remove
        var elementPos = this.issues.map(function (x) { return x.ISSUEID; }).indexOf(issue.ISSUEID);
        this.issues[elementPos].checked = false;
      }
      console.log('selected',this.selected);   
    }
  classify() {
      if (this.issues.length !== 0) {
          this.loader = true;
      } else {
          this.loader = false;
      }
      for (const issue of this.issues) {
          /* Send each issue to the ML engine and get the classification*/
          let headers = new HttpHeaders();
          headers = headers.append('Content-Type', 'application/json');
          let reqBody = {};
          reqBody = [{
              'id':issue.ISSUEID,
              'Defect Description' : issue.DESCRIPTION,
              'data_Source' : issue.SOURCE
          }];
          this.http.post(encodeURI(this.hostUrl + '/api/engine/classification/' + this.projectId), reqBody,{headers: headers})
              .subscribe(data => {                    
                  let labelledData=JSON.parse(data['prediction'])[0];
                  
                  this.prediction = labelledData['classification']; 
                  this.prediction1 = labelledData['AssignedTo'];                  
                  /* Update Classification in the Database */
                  let headers = new HttpHeaders();
                  headers = headers.append('Content-Type', 'application/json');
                  let updateBody = {};
                  
                  updateBody = {'classification' : this.prediction,'AssignedTo' :this.prediction1};
                  this.http.post(encodeURI(this.hostUrl + '/api/issue/updateclass/' + issue.ISSUEID.toString()), updateBody, {headers: headers})
                      .subscribe(data => {
                          this.loader = false;
                          const url = '/cqmns-validate-defect';
                           this.router.navigate([url]);
                          for (let i = 0; i < this.issues.length; i++) {
                              if (this.issues[i].issueID === issue.ISSUEID) {
                                  this.issues.splice(i, 1);
                                  this.count--;
                              }
                          }
                          if (this.issues.length === 1) {
                              setTimeout(() => {const url = '/cqmns-validate-defect';
                                  this.router.navigate([url]); }, 1000);
                          }
                      });

                  /* Update Classification in JIRA */
                  updateBody = { 'classification': this.prediction.toString(), 'AssignedTo': this.prediction1.toString() };
                  this.http.post(encodeURI(this.hostUrl+'/api/jira/update/' + this.projectId + '/' + issue.ISSUEID) , JSON.stringify(updateBody), {headers: headers})
                      .subscribe();
                  /* Update Suggestion in JIRA */
                  updateBody = {'description' : issue.DESCRIPTION.toString().toLowerCase()};
                  this.http.post(encodeURI(this.hostUrl+'/api/jira/suggest/' + this.projectId + '/' + issue.ISSUEID ), JSON.stringify(updateBody), { headers : headers})
                      .subscribe();
              });
      }
  }
  scan() {
    const url = '/scan/' + this.projectId;
    this.router.navigate([url]);
}

  sortBy(field){
    if(this.oldField==field){
        this.isDesc = !this.isDesc;
        this.order=!this.order;
    } else {
        this.isDesc = false;
        this.order=false;
        this.oldField=field;
    }
    if(this.order){
        field="-"+field;
    }
    if (field === 'review_date' || field === '-review_date') {
        this.sortreview_date = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
        this.sortsource = "fa fa-sort";
        this.sortDescription = "fa fa-sort";
    } else if (field === 'source' || field === '-source') {
        this.sortsource = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
        this.sortreview_date = "fa fa-sort";
        this.sortDescription = "fa fa-sort";
    } else if (field === 'Description' || field === '-Description') {
        this.sortDescription = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
        this.sortsource = "fa fa-sort";
        this.sortreview_date = "fa fa-sort";
    }
    this.issues=this.issues.sort(this.userService.dynamicSort(field))
    console.log(this.issues)
}
projectPopup() {
    

  const dialogConfig = new MatDialogConfig();

  // dialogConfig.panelClass = "login-modalbox";

  dialogConfig.backdropClass = 'popupBackdropClass';

  dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 

  dialogConfig.panelClass = "ns-modalbox";
  dialogConfig.disableClose = false;
  this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

}
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-actions/cqmns-scan-defect/cqmns-scan-defect.component.ts